
// Get Products
export const FETCH_PRODUCTS_BEGIN = 'FETCH_PRODUCTS_BEGIN'
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const FETCH_SINGLE_PRODUCT = 'FETCH_SINGLE_PRODUCT'

// FILTERS
export const FILTER_COLOR = 'FILTER_COLOR'
export const FILTER_CATEGORY = 'FILTER_CATEGORY'
export const FILTER_SIZE = 'FILTER_SIZE'
export const FILTER_PRICE = 'FILTER_PRICE'
export const SORT_BY = 'SORT_BY'
export const FILTER_RATING = 'FILTER_RATING'


export const CHANGE_CURRENCY = 'CHANGE_CURRENCY'

